














import Vue from 'vue'
import Navbar from '@/components/Navbar/index.vue'
import c from '@/config'

export default Vue.extend({
  data() {
    return {
      value: '',
      c,
    }
  },
  components: {
    Navbar,
  },
  watch: {
    value(val) {
      this.$store.commit('machine/overview/setTargetNumber', val)
    },
  },
})
